import ApiService from "@/gapp-components/services/api.service";
import UtilService from "@/gapp-components/services/util.service";

const BASE_URL = "/api/claimTypes";

export default {
  search(searchForm = {}, params = new URLSearchParams()) {
    return ApiService.post(`${BASE_URL}/search?${params.toString()}`, searchForm);
  },

  findAll(searchForm = {}, pageSize = 100, expands = []) {
    return UtilService.fetchPaginatedData(`${BASE_URL}/search`, searchForm, pageSize, expands);
  }
};
